import { RequestState } from "vuex-fetch-factory";
import { LicenseModel } from "../models";

export interface StateInterface {
  vuexFetchersState: Map<string, Map<string, RequestState>>;
  current: LicenseModel;
}

export const state: StateInterface = {
  vuexFetchersState: new Map(),
  current: new LicenseModel()
};

export default state;
